import { render, staticRenderFns } from "./VistaProforma.vue?vue&type=template&id=6bb98190"
import script from "./VistaProforma.vue?vue&type=script&lang=js"
export * from "./VistaProforma.vue?vue&type=script&lang=js"
import style0 from "./VistaProforma.vue?vue&type=style&index=0&id=6bb98190&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports